"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.registerPlugin = registerPlugin;

var _variables = require("./variables");

var _beacon = require("./beacon");

var _page = require("./page");

var context = {
  addVariable: _variables.addVariable,
  removeVariable: _variables.removeVariable,
  sendBeacon: _beacon.sendBeacon,
  sendBeaconWhenReady: _beacon.sendBeaconWhenReady
};

function registerPlugin(plugin) {
  var delegate = plugin(context);

  if (delegate != null) {
    (0, _page.addPageDelegate)(delegate);
    (0, _beacon.addBeaconDelegate)(delegate);
  }
}